<div class="d-grid grid-column gp-20 ">
  <div class="d-flex flex-column justify-content-center align-items-start w-100 list-of-vehicle">
    <div class="position-relative mt-3">
      <img *ngIf="content?.image" src="{{ content?.image }}" class="card-img-top " alt="monotainer">
      <img *ngIf="!content?.image" [src]="service.getDefaultImageByCategory(content?.category)" class="card-img-top" alt="monotainer">
    </div>
  </div>
  <div class="d-flex flex-column justify-content-center w-100 mt-3">
    <div>
      <div class="tile-data-cp">
        <div class="details-font">{{ content?.assetDetails?.name }}</div>
        <div class="cpdetail-color">Destination: <span
            class="details-font">{{ content?.assetDetails?.destination }}</span>
        </div>
        <div class="cpdetail-color">Tagged By: <span class="details-font">{{ content?.assetDetails?.taggedBy }}</span>
        </div>
        <div>
          <img src="../../../../assets/images/location-icon.svg" class="h-15 mr-2" alt="blackbell" *ngIf="content?.assetDetails?.zones?.length">
          <span class="details-font">
            <span *ngFor="let zone of content?.assetDetails?.zones; let i=index">
              {{ zone?.name }}
              <span *ngIf="content?.assetDetails?.zones?.length">,</span>
            </span>
            {{ content?.assetDetails?.destination }}</span>
        </div>
      </div>
    </div>
  </div>
</div>